module.exports = __webpack_public_path__ + "img/videointerview.95143ee0.svg";